import label from "@/lang/StaticLabels.js";

// PWHRS Navbar -----------------------------------------------
let navItems = [
  {
    title: label.modules.pwhrs,
    icon: "mdi-map-marker-radius",
    to: false,
  },
  {
    to: "PWHRSDashboard",
    label: label.menu.dashboard,
    icon: "pi pi-home",
    active: false,
    subItems: false,
    divider: true,
  },
  {
    to: null,
    label: label.menu.baseInformation,
    icon: "pi pi-database",
    active: false,
    subItems: [
      {
        to: "PWHRSWareCategory",
        label: label.menu.wareCategory,
        metaLabel: label.page.wareCategory,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PWHRSWareList",
        label: label.menu.wares,
        metaLabel: label.page.wares,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PWHRSWareVoucherTypeList",
        label: label.menu.wareVoucherType,
        metaLabel: label.page.wareVoucherType,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PWHRSUnit",
        label: label.menu.unit,
        metaLabel: label.page.unit,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PWHRSCommodityCategory",
        label: label.menu.category,
        metaLabel: label.page.category,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PWHRSCommodityList",
        label: label.menu.commodities,
        metaLabel: label.page.commodity,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PWHRSCommodityBatch",
        label: label.menu.commodityBatch,
        metaLabel: label.page.commodityBatch,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PWHRSAdditionalCommodityParameter",
        label: label.menu.additionalCommodityParameter,
        metaLabel: label.page.additionalCommodityParameter,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PWHRSPackageTypes",
        label: label.menu.packageTypes,
        metaLabel: label.page.packageTypes,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PWHRSystemSetting",
        label: label.menu.settings,
        metaLabel: label.page.wareSetting,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
    ],
  },
  {
    to: null,
    label: label.menu.operation,
    icon: "mdi-wrench-outline",
    active: false,
    subItems: [
      {
        to: null,
        label: label.menu.tempReceipt,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [
          {
            to: "PWHRSAddTempReceipt",
            label: label.menu.addTempReceipt,
            metaLabel: label.page.addTempReceipt,
            icon: "mdi-circle-small",
          },
          {
            to: "PWHRSTempReceiptList",
            label: label.menu.tempReceiptList,
            metaLabel: label.page.tempReceipt,
            icon: "mdi-circle-small",
          },
          {
            to: "PWHRSTempReceiptCartable",
            label: label.menu.tempReceiptCartable,
            metaLabel: label.page.tempReceiptCartable,
            icon: "mdi-circle-small",
          },
          {
            to: "PWHRSTempReceiptExitCartable",
            label: label.menu.tempReceiptExitCartable,
            metaLabel: label.page.tempReceiptExitCartable,
            icon: "mdi-circle-small",
          },
        ],
      },
      {
        to: null,
        label: label.menu.receipt,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [
          {
            to: "PWHRSAddSomeWareReceipt",
            label: label.menu.addSomeWareReceipt,
            metaLabel: label.page.addSomeWareReceipt,
            icon: "mdi-circle-small",
          },
          {
            to: "PWHRSAddFinancialReceipt",
            label: label.menu.addFinancialReceipt,
            metaLabel: label.page.addFinancialReceipt,
            icon: "mdi-circle-small",
          },
          {
            to: "PWHRSReceiptList",
            label: label.menu.receiptList,
            metaLabel: label.page.receiptList,
            icon: "mdi-circle-small",
          },
          {
            to: "PWHRSSortReceipts",
            label: label.menu.sortReceipts,
            metaLabel: label.page.sortReceipts,
            icon: "mdi-circle-small",
          },
          {
            to: "PWHRSFinancialReceiptCartable",
            label: label.menu.financialReceiptCartable,
            metaLabel: label.page.financialReceiptCartable,
            icon: "mdi-circle-small",
          },
          {
            to: "PWHRSVerificationReceiptCartable",
            label: label.menu.confirmReceiptCartable,
            metaLabel: label.page.confirmReceiptCartable,
            icon: "mdi-circle-small",
          },
        ],
      },
      {
        to: null,
        label: label.menu.draftRequest,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [
          {
            to: "PWHRSAddDraftRequest",
            label: label.menu.addDraftRequest,
            metaLabel: label.page.addDraftRequest,
            icon: "mdi-circle-small",
          },
          {
            to: "PWHRSDraftRequestList",
            label: label.menu.draftRequestList,
            metaLabel: label.page.draftRequest,
            icon: "mdi-circle-small",
          },
          {
            to: "PWHRSDraftRequestCartable",
            label: label.menu.draftRequestCartable,
            metaLabel: label.page.draftRequestCartable,
            icon: "mdi-circle-small",
          },
        ],
      },
      {
        to: null,
        label: label.menu.draft,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [
          {
            to: "PWHRSAddSomeWareDraft",
            label: label.menu.addSomeWareDraft,
            metaLabel: label.page.addSomeWareDraft,
            icon: "mdi-circle-small",
          },
          {
            to: "PWHRSAddFinancialDraft",
            label: label.menu.addFinancialDraft,
            metaLabel: label.page.addFinancialDraft,
            icon: "mdi-circle-small",
          },
          {
            to: "PWHRSDraftList",
            label: label.menu.draftList,
            metaLabel: label.page.draftList,
            icon: "mdi-circle-small",
          },
          {
            to: "PWHRSSortDrafts",
            label: label.menu.sortDrafts,
            metaLabel: label.page.sortDrafts,
            icon: "mdi-circle-small",
          },
          {
            to: "PWHRSVerificationDraftCartable",
            label: label.menu.confirmDraftCartable,
            metaLabel: label.page.confirmDraftCartable,
            icon: "mdi-circle-small",
          },
          {
            to: "PWHRSFinancialDraftCartable",
            label: label.menu.financialDraftCartable,
            metaLabel: label.page.financialDraftCartable,
            icon: "mdi-circle-small",
          },
        ],
      },
      {
        to: null,
        label: label.menu.transferCommodity,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [
          {
            to: "PWHRSAddInstantTransfer",
            label: label.menu.addInstantTransfer,
            metaLabel: label.page.addInstantTransfer,
            icon: "mdi-circle-small",
          },
          {
            to: "PWHRSAddProccessTransfer",
            label: label.menu.addProccessTransfer,
            metaLabel: label.page.addProccessTransfer,
            icon: "mdi-circle-small",
          },
          {
            to: "PWHRSTransferCommodityList",
            label: label.menu.transferCommodityList,
            metaLabel: label.page.transferCommodity,
            icon: "mdi-circle-small",
          },
          {
            to: "PWHRSProccessTransferCartable",
            label: label.menu.proccessTransferCartable,
            metaLabel: label.page.proccessTransferCartable,
            icon: "mdi-circle-small",
          },
        ],
      },
      {
        to: null,
        label: label.menu.financialCartable,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [
          {
            to: "PWHRSIssueBuyFactor",
            label: label.menu.issueBuyFactor,
            metaLabel: label.page.issueBuyFactor,
            icon: "mdi-circle-small",
          },
          {
            to: "PWHRSIssueReturnBuyFactor",
            label: label.menu.issueReturnBuyFactor,
            metaLabel: label.page.issueReturnBuyFactor,
            icon: "mdi-circle-small",
          },
          {
            to: "PWHRSIssueSaleFactor",
            label: label.menu.issueSaleFactor,
            metaLabel: label.page.issueSaleFactor,
            icon: "mdi-circle-small",
          },
          {
            to: "PWHRSIssueReturnSaleFactor",
            label: label.menu.issueReturnSaleFactor,
            metaLabel: label.page.issueReturnSaleFactor,
            icon: "mdi-circle-small",
          },
        ],
      },
      {
        to: null,
        label: label.menu.managementCartable,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [
          {
            to: "PWHRSManagementCartableReceipt",
            label: label.menu.receipt,
            metaLabel: label.page.managementCartableReceipt,
            icon: "mdi-circle-small",
          },
          {
            to: "PWHRSManagementCartableDraft",
            label: label.menu.draft,
            metaLabel: label.page.managementCartableDraft,
            icon: "mdi-circle-small",
          },
        ],
      },
      {
        to: "PWHRSCommodityConversion",
        label: label.menu.commodityConversion,
        metaLabel: label.page.commodityConversion,
        icon: "mdi-subdirectory-arrow-left",
        active: true,
        subItems: [],
      },
      {
        to: "PWHRSWarehousingList",
        label: label.menu.warehousing,
        metaLabel: label.page.warehousing,
        icon: "mdi-subdirectory-arrow-left",
        active: true,
        subItems: [],
      },
      // {
      //   to: "PWHRSCartableLog",
      //   label: label.menu.cartableLog,
      //   metaLabel: label.page.cartableLog,
      //   icon: "mdi-subdirectory-arrow-left",
      //   active: true,
      //   subItems: [],
      // },
    ],
  },
  {
    to: null,
    label: label.menu.reports,
    icon: "mdi-chart-bar-stacked",
    active: false,
    subItems: [
      {
        to: null,
        label: label.menu.wareVouchers,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [
          {
            to: "PWHRSSomeVouchers",
            label: label.menu.wareSomeVouchers,
            metaLabel: label.page.wareSomeVouchers,
            icon: "mdi-circle-small",
          },
          {
            to: "PWHRSFinancialVouchers",
            label: label.menu.wareFinancialVouchers,
            metaLabel: label.page.wareFinancialVouchers,
            icon: "mdi-circle-small",
          },
        ],
      },
      {
        to: null,
        label: label.menu.circulationCommodity,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [
          {
            to: "PWHRSSomeCirculation",
            label: label.menu.someCirculation,
            metaLabel: label.page.someCirculation,
            icon: "mdi-circle-small",
          },
          {
            to: "PWHRSFinancialCirculation",
            label: label.menu.financialCirculation,
            metaLabel: label.page.financialCirculation,
            icon: "mdi-circle-small",
          },
        ],
      },
      {
        to: null,
        label: label.menu.wareInventory,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [
          {
            to: "PWHRSSomeInventory",
            label: label.menu.someInventory,
            metaLabel: label.page.someInventory,
            icon: "mdi-circle-small",
          },
          {
            to: "PWHRSFinancialInventory",
            label: label.menu.financialInventory,
            metaLabel: label.page.financialInventory,
            icon: "mdi-circle-small",
          },
        ],
      },
      {
        to: null,
        label: label.menu.cardex,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [
          {
            to: "PWHRSSomeCardex",
            label: label.menu.someCardex,
            metaLabel: label.page.someCardex,
            icon: "mdi-circle-small",
          },
          {
            to: "PWHRSFinancialCardex",
            label: label.menu.financialCardex,
            metaLabel: label.page.financialCardex,
            icon: "mdi-circle-small",
          },
        ],
      },
      {
        to: null,
        label: label.menu.otherReports,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [
          {
            to: "PWHRSInventoryDeduction",
            label: label.menu.inventoryDeductionReport,
            metaLabel: label.page.inventoryDeductionReport,
            icon: "mdi-circle-small",
          },
          {
            to: "PWHRSInventorySummaryReport",
            label: label.menu.inventorySummaryReport,
            metaLabel: label.page.inventorySummaryReport,
            icon: "mdi-circle-small",
          },
          {
            to: "PWHRSCommoditySleepReport",
            label: label.menu.commoditySleepReport,
            metaLabel: label.page.commoditySleepReport,
            icon: "mdi-circle-small",
          },
          {
            to: "PWHRSNegativeCommodityInventory",
            label: label.menu.negativeCommodityInventory,
            metaLabel: label.page.negativeCommodityInventory,
            icon: "mdi-circle-small",
          },
          {
            to: "PWHRSCommodityCirculationReport",
            label: label.menu.commodityCirculationReport,
            metaLabel: label.page.commodityCirculationReport,
            icon: "mdi-circle-small",
          },
        ],
      },
    ],
  },
];

export default navItems;
